import { AcrValue } from '../types';

export const formatAcrValue = (...tokens: (string | undefined)[]): AcrValue =>
    tokens.filter((t) => !!t).join(':') as AcrValue;
